<script>
import materialOption from './material-option'

import store from '../store'

// const imagePath = require.context('../assets/textures/', true)

export default {
  name: 'materialItem',
  components: {
    materialOption
  },
  props: {
    materialOptions: Array,
    materialName: String
  },
  data: function () {
    return {
      toggleMenu: false
    }
  },
  computed: {
    currentMaterial () {
      return store.getters['materialList/getMaterialByProperty']('name', this.materialName)
    }
  },
  methods: {
    closeMenu () {
      this.toggleMenu = false
    },
    openMenu () {
      this.toggleMenu = true
    },
    highlight () {
      // just adding the click event adds a highlight to a menu item
    },
    getIconPath (icon) {
      const imagePath = require.context('../assets/textures/', true)
      // eslint-disable-next-line
      return API_URL + imagePath(icon, true)
    }
  }
}
</script>

<template>
<md-menu :md-close-on-select="false" :md-close-on-click="false" md-direction="bottom-start" md-size="huge" @click="openMenu" :md-active.sync="toggleMenu">

  <md-list-item md-menu-trigger @click="highlight">
    <span class="md-list-item-text">{{currentMaterial.currentTitle}}</span>
    <md-button v-if="currentMaterial.swatch != null" :style="currentMaterial.swatch" class="md-icon-button md-raised"></md-button>
    <md-button v-if="currentMaterial.icon != null" class="md-icon-button md-raised">
      <md-avatar>
        <img :src="getIconPath(currentMaterial.icon)">
      </md-avatar>
    </md-button>
    <md-icon>arrow_drop_down</md-icon>
  </md-list-item>

  <md-menu-content>
    <md-menu-item>
      <span class="md-title">{{currentMaterial.title}}</span>
      <md-button class="md-icon-button md-raised md-accent" @click="closeMenu">
        <md-icon>close</md-icon>
      </md-button>
    </md-menu-item>

    <md-divider></md-divider>
    <div v-for="(option, index) in materialOptions" :key="index">
      <materialOption v-bind:option="option" v-bind:materialName="materialName"/>
    </div>
  </md-menu-content>

</md-menu>
</template>

<style lang="scss" scoped>
  .md-menu {
    width: 300px;
    max-width: 100%;
    display: inline-block;
  }
</style>
